(function() {
  var isMobile = window.innerWidth < 750 ? true : false;

  if (isMobile) return;
  
  function roundToPlace(num, place) {
    return Math.round(num * Math.pow(10, place)) / Math.pow(10, place);
  }

  var loupeElements = document.querySelectorAll('.js-loupe');

  loupeElements.forEach(function(loupe) {
    var image = loupe.querySelector('.js-loupe-image');
    var imgBigUrl = image.getAttribute('data-image-full');
    var loupeElement = loupe.querySelector('.js-loupe-element');
    loupeElement.style.backgroundImage = 'url(' + imgBigUrl + ')';
    var loupeSize = [loupeElement.offsetWidth, loupeElement.offsetHeight];
    var bigImgSize = [0, 0];
    var zoomLvl = 1;
    var bigImg = new Image();
    bigImg.onload = function() {
      bigImgSize = [bigImg.width, bigImg.height];
    };
    bigImg.src = imgBigUrl;

    loupe.addEventListener('mousemove', function(e) {
      var positionRatio = [
        roundToPlace(e.offsetX / image.offsetWidth, 3),
        roundToPlace(e.offsetY / image.offsetHeight, 3)
      ];

      var offset = [
        (loupeSize[0] * positionRatio[0]) - (loupeSize[0] / 2),
        (loupeSize[1] * positionRatio[1]) - (loupeSize[1] / 2)
      ];

      var positionPercent = [
        'calc(' + positionRatio[0] * 100 + '% - ' + offset[0] + 'px)',
        'calc(' + positionRatio[1] * 100 + '% - ' + offset[1] + 'px)'
      ];

      loupeElement.style.backgroundPosition = positionPercent.join(' ');
      loupeElement.style.top = e.offsetY + 'px';
      loupeElement.style.left = e.offsetX + 'px';
    });

    loupe.addEventListener('mousewheel', function(event) {
      event.preventDefault();
      if (event.wheelDelta > 0) {
        if (zoomLvl < 1.5) {
          zoomLvl += 0.1;
          loupeElement.style.backgroundSize = bigImgSize[0] * zoomLvl + 'px ' + bigImgSize[1] * zoomLvl + 'px';
        }
      } else {
        if (zoomLvl > 0.5) {
          zoomLvl -= 0.1;
          loupeElement.style.backgroundSize = bigImgSize[0] * zoomLvl + 'px ' + bigImgSize[1] * zoomLvl + 'px';
        }
      }
    });
  });
})();